import { createSlice } from "@reduxjs/toolkit";
import { PredictionReducerType } from "../../types/PredictionTypes";

const initialState: PredictionReducerType = {
  predictionRunningState: "idle",
  predictionSubmitState: "idle",
  predictionStep: 1,
  predictionData: null,
};

const PredictionSlice = createSlice({
  name: "PredictionReducer",
  initialState,
  reducers: {
    updatePredictionRunningState: (nextState, { payload }) => {
      nextState.predictionRunningState = payload;
    },
    updatePredictionStep: (nextState, { payload }) => {
      nextState.predictionStep = payload;
    },
    updatePredictionData: (nextState, { payload }) => {
      nextState.predictionData = payload;
    },

    updatePredictionSubmitState: (nextState, { payload }) => {
      nextState.predictionSubmitState = payload;
    },

    // @TODO - try to use Object.keys().map()...
    resetPredictionSlice: (nextState) => {
      nextState.predictionRunningState = "idle";
      nextState.predictionSubmitState = "idle";
      nextState.predictionStep = 1;
      nextState.predictionData = null;
    },
  },
});

export const {
  updatePredictionRunningState,
  updatePredictionSubmitState,
  updatePredictionStep,
  updatePredictionData,
  resetPredictionSlice,
} = PredictionSlice.actions;

export const { reducer: PredictionReducer } = PredictionSlice;
